export default __webpack_public_path__ + "static/media/framer.5b6f82a3.svg";